<template>
  <DialogSetting 
    :show="isShowRoomSettings"
    :configs="room_config"
    :choosed-item.sync="choosedItem"
    @bgClick="closeSetting"
    @esc="closeSetting"
    class="cpt-dialog-room-setting"
    ref="dialog-setting"
    :clickBlockCallback='clickBlockCallback'
  >
    <template #side-last>
      <div class="text-btn alert" @click="deleteHomeHandler" v-if="is_master">
        <span>删除房间</span>
      </div>
    </template>
    <template #content>
      <component
        :is="curShowComponent.key"
        :key="curShowComponent.key"
        :form="settingForm"
        :show="isShowRoomSettings"
        :channels="channelList"
        @close="closeSetting"
        @updateSetting="handleUpdateSetting"
        @moveMember="handleRoleChangePos"
        @refreshChannel="getChannels"
      />
    </template>
  </DialogSetting>
</template>

<script>

import MemberManage from './setting-components/MemberManage.vue';
import RoomBotManage from './setting-components/RoomBotManage.vue';
import DialogSetting from '@/components/setting/DialogSetting.vue';
import RoomBase from './setting-components/RoomBase.vue';
const RoleManage = () => import('./setting-components/RoleManage.vue');
const EmojiPasterManage = () => import('./setting-components/Emoji-paster-manage.vue');
const RoomLaughterTrackManage = () => import('./setting-components/RoomLaughterTrackManage.vue');
const NewMemberGuide = () => import('./setting-components/NewMemberGuide.vue');
const SafetyManage = () => import('./setting-components/SafetyManage.vue');
const ChannelManage = () => import('./setting-components/ChannelManage.vue');
const RoomData = () => import('./setting-components/RoomData.vue');
import { getRoomInfo, getRoomSetting, getRoomLevels, getRoomNotify } from "_api/room/index";
import { getRoomLaughter } from '_api/voice'
import { getFullChannelList } from '_api/channel';

import { mapActions, mapGetters, mapMutations } from "vuex";
import { ROOM_CONFIG } from './setting-config';
import EventBus from '@/common/EventBus';
import { ROLE_CREATE, ROLE_TYPES } from '_lib/constants/role';
const defaultItem = ROOM_CONFIG[0].data[0].key;
const DEFAULT_ROOM_LAUGHTER_NUM_LIMIT = 30
export default {
  name: 'RoomSettings',
  components: {
    DialogSetting,
    SafetyManage,
    RoleManage,
    MemberManage,
    ChannelManage,
    EmojiPasterManage,
    RoomLaughterTrackManage,
    NewMemberGuide,
    RoomData,
    RoomBotManage,
    RoomBase,
  },
  data() {
    return {
      isShowRoomSettings: false,
      settingForm: {
        room: {},
        room_voice_packs: [],
      },
      choosedItem: defaultItem, 
      blockHeights: [],
      room_voice_packs: [],
      updateKey: 0,
      channelList: [],
    }
  },
  computed: {
    ...mapGetters(['cur_room_data', 'user_info', 'setting_data', 'channels', 'cur_room_data_is_big']),
    room_config () {
      // 过滤掉没有权限的组件，只要有其中一个权限就进行显示
      let config = JSON.parse(JSON.stringify(ROOM_CONFIG))
      for (let i in config) {
        let group = config[i]
        for (let j in group.data) {
          let item = group.data[j]
          if(item.key === 'new-member-guide'){
            // 单独对新手教程进行判断 公开且允许才能开放新手教程
            const isPublic = this.cur_room_data.is_public
            item.isHidden = !isPublic
            continue
          }
          if(item.key === 'room-data'){
            // 单独对房间数据进行判断
            item.isHidden = !this.cur_room_data.show_room_active
            continue
          }
          let isHidden = true
          if (!item.requirePermissions || item.requirePermissions.length === 0) {
            isHidden = false
          } else {
            for (let permission of item.requirePermissions || []) {
              if (this.$permission.judge(permission)) {
                isHidden = false
                break
              }
            }
          }
          item.isHidden = isHidden
        }
      }
      return config
    },
    contentComponents() {
      return this.room_config.map(item => item.data).flat();
    },
    is_master () {
      return this.cur_room_data.create_by && this.cur_room_data.create_by == this.user_info.user_id
    },
    curShowComponent() {
      return this.contentComponents.find(item => item.key === this.choosedItem) || {
        componentName:"room-info",
        isHidden:false,
        key:"room-info",
        title:"基础资料",
      }
    },
  },
  created() {
    this.getChannels()
  },
  mounted() {
    EventBus.$on('Change_Choose_Item', this.handleChangeChooseItem)
  },
  beforeDestroy() {
    EventBus.$off('UPDATE_ROOM_SETTINGS_DATA', this.updateRoomSettingsData);
    EventBus.$off('Refresh_Room_Laughter', this.refreshRoomLaughter)
    EventBus.$off('Change_Choose_Item', this.handleChangeChooseItem)
    if(this.cur_room_data_is_big) {
      EventBus.$off('channels-update', this.getChannels)
    }
  },
  watch: {
    isShowRoomSettings(v) {
      if (v) {
        EventBus.$on('UPDATE_ROOM_SETTINGS_DATA', this.updateRoomSettingsData);
        EventBus.$on('Refresh_Room_Laughter', this.refreshRoomLaughter)
        if(this.cur_room_data_is_big) {
          EventBus.$on('channels-update', this.getChannels)
        }
      } else {
        EventBus.$off('UPDATE_ROOM_SETTINGS_DATA', this.updateRoomSettingsData);
        EventBus.$off('Refresh_Room_Laughter', this.refreshRoomLaughter)
        if(this.cur_room_data_is_big) {
          EventBus.$off('channels-update', this.getChannels)
        }
      }
    },
    'settingForm.room_voice_packs': {
      handler: function(val) {
        this.updateKey++
      },
      deep: true
    },
    channels: {
      handler(v) {
        if(!this.cur_room_data_is_big) {
          this.channelList = v
        }
      }
    }
  },
  methods: {
    async init(data, choosed, afterRealInitCb) {
      if (data === false) {
        this.isShowRoomSettings = false;
        return
      }
      data = data || this.cur_room_data
      this.realInit(data, choosed, afterRealInitCb)
    },
    // 获取各个模块的数据
    realInit (data, choosed, afterRealInitCb) {
      Promise.all([
        this.getRoomSetting(),
        this.updateRoomSettingsData(data),
        this.getRoomLevels(),
        this.getRoomLaughterList(),
        this.getRoomNotifySetting(),
      ]).then(() => {
        this._realInited = true
        this.updateVoicePacks()
        this.isShowRoomSettings = true;
        this.choosedItem = defaultItem
        if (choosed) {
          this.choosedItem = choosed
        }
        this.$nextTick(() => {
          afterRealInitCb && afterRealInitCb()
        })
      })
    },
    getChannels() {
      getFullChannelList({
        room_id: this.cur_room_data.room_id,
        is_password: true,
      }).then(res => {
      if(res.data.status === 'ok') {  
          this.channelList = res.data.result.channels
        }
      })
    },

    async getRoomLevels () {
      const { data } = await getRoomLevels()
      if (data.status == 'ok') {
        const room_level_list = data.result.rights || []
        let reg = /\$\{(.*?)\}/g
        room_level_list.forEach(item => {
          if (item.tasks?.length) {
            let task_desc = ''
            item.tasks.forEach(task => {
              task_desc += task.task_desc.replaceAll(reg, (str, key) => {
                if (task[key]) {
                  return `<span>${task[key]}</span>`
                }
                return str
              })
              task_desc += '  '
            })
            item.task_desc = task_desc
          }
        })
        this.$set(this.settingForm, 'room_level_list', room_level_list)
      }
    },
    async refreshRoomLaughter() {
      await this.getRoomLaughterList()
      this.updateVoicePacks()
    },
    async getRoomLaughterList() {
      await getRoomLaughter({
        room_id: this.cur_room_data.room_id
      }).then((res) => {
        if(res.data.status == 'ok') {
          let { room_voice_packs } = res.data.result
          this.room_voice_packs = room_voice_packs || []
        }
      })
    },
    updateVoicePacks() {
      if (!this._realInited) return

      if(this.room_voice_packs.length < (this.settingForm.roomLimitSetting?.voice_pack || DEFAULT_ROOM_LAUGHTER_NUM_LIMIT)) {
        this.room_voice_packs.unshift({
          type: 'add',
          path: '-1',
        })
      }
      this.$set(this.settingForm, 'room_voice_packs', this.room_voice_packs)
    },
    getRoomSetting () {
      getRoomSetting({
        room_id: this.cur_room_data.room_id
      }).then(({ data }) => {
        if (data.status == 'ok') {
          const settings = data.result.setting || {}
          this.$set(this.settingForm, 'roomLimitSetting', settings.RoomLimitSetting || {})
          this.$set(this.settingForm, 'communitySetting', settings.community)
        }
      })
    },
    async updateRoomSettingsData(data, updateStoreKey) {
      let roomId = data.room ? data.room.room_id : '';
      if (!roomId) {
        roomId = this.cur_room_data.room_id
        data.room = this.cur_room_data;
      }
      this.settingForm = {
        ...this.settingForm,
        ...data
      }
      if (roomId) {
        const res = await getRoomInfo({room_id: roomId});
        if (res.data.status == 'ok') {
          const { room_info } = res.data.result;
          this.settingForm = {
            ...this.settingForm,
            ...room_info
          }
          if(updateStoreKey){
            this.SET_CUR_ROOM_WHOLE_DATA_KEY({
              key: updateStoreKey,
              value: room_info[updateStoreKey]
            })
          }
          this.SET_CUR_ROOM_WHOLE_DATA_KEY({
            key: 'bot_infos',
            value: room_info.bot_infos
          })
        }
      }
    },
    
    closeSetting() {
      this.isShowRoomSettings = false;
      this.$emit('close');
    },
    deleteHomeHandler() {
      EventBus.$dynamic('RoomDelete', {
        room_id: this.settingForm.room.room_id,
        cb: this.closeSetting
      })
    },
    clickBlockCallback(key){
      const curNewKeys = ['safety-manage','new-member-guide', 'room-default-setting', 'room-data']
      if(curNewKeys.includes(key) && !this.setting_data.new_config_clicked_list.includes(key)) {
        const flatList = ROOM_CONFIG.reduce((acc,cur)=>{
          const {data} = cur
          return [...acc,...data]
        }, [])
        let newConfigItems = flatList.filter((item) => item.isNew)
        let clickedList = this.setting_data.new_config_clicked_list.concat(key).filter((k) => {
          return newConfigItems.some((item) => item.key === k)
        })
        this.SET_SETTING_DATA_PARAM({
          new_config_clicked_list: clickedList
        })
      }
    },
    handleUpdateSetting({key, value}){
      this.SET_CUR_ROOM_WHOLE_DATA_KEY({ key, value })
      this.$set(this.settingForm, key, value)
    },
    async getRoomNotifySetting(){
      const { data: { status, result } } = await getRoomNotify(this.settingForm.room.room_id)
      if(status === 'ok'){
        const { setting } = result
        this.$set(this.settingForm, 'room_notify_setting', setting)
      }
    },
    handleRoleChangePos(roleIds) {
      const roleList = this.settingForm.roles
      const ignores = [ROLE_TYPES.everyone, ROLE_TYPES.tourist, ROLE_TYPES.punish];
      const normalRoles = roleList.filter(item => roleIds.includes(item.id));
      const sortedRoles = []
      for(let i = 0; i < roleIds.length; i++) {
        const id = roleIds[i]
        const role = normalRoles.find(item => item.id === id)
        if(role) {
          sortedRoles.push(role)
        }
      }

      const staticRoles = roleList.filter(item => ignores.includes(item.type));
      this.$set(this.settingForm, 'roles', [...staticRoles, ...sortedRoles]);
    },
    handleChangeChooseItem(key) {
      this.choosedItem = key
      this.clickBlockCallback(key)
    },
    ...mapActions(['SET_SETTING_DATA_PARAM']),
    ...mapMutations(['SET_CUR_ROOM_WHOLE_DATA_KEY']),
  }
}
</script>
<style lang="scss">
.cpt-dialog-room-setting {
  .text-btn {
    width: 100%;
    height: 36px;
    margin: 4px 0 4px 0;
    display: flex;
    align-items: center;
    padding: 8px 8px 10px 8px;
    float: right;
    cursor: pointer;
  
    span {
      flex: 1;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
    }
    &.alert {
      color: $d-er-tx;
    }
  }
  .scroll-item-wrapper {
    &::after {
      display: none;
    }
  }
}
</style>